import http from './axios';

export interface SubjectDto {
  id?: number;
  isFieldsChange?: number;
  // 主题表编码
  subCode?: string;
  // 主题表名称
  subName?: string;
  // 主题表分区方式 N-不创建分区，D: 按日创建分区，M:按月创建分区，Y: 按年创建分区
  subPartition?: string;
  // 主题表标签
  subLabel?: string;
  // 主题表描述
  subDescription?: string;
  // 主题表目录
  subCategoryId?: number;
  // 主题表排序
  subSort?: number;
  // 使用状态 0-启用，1-禁用
  status?: number;
  // 维度属性列表
  subFieldList?: any[];
  // 系统维度数据同步定义
  subSyncDefs?: any;
  // 是否已虚拟方式同步数据
  isVirtualMode?: any;
  approveStatus?: number;
}

export interface SubjectItemDto {
  id?: number;
  // 主题表编码
  subCode?: string;
  // 字段编码
  fieldCode?: string;
  // 字段名称
  fieldName?: string;
  // 字段类型
  fieldType?: number;
  // 字段类别 0-数据期,1-维度值，2-度量值，3-属性值
  fieldCategory?: number | string;
  // 字段排序
  fieldSort?: number;
  // 关联维度表编码
  refDimCode?: string;
  // 关联维度表字段编码
  refDimFieldCode?: string;
  // 使用状态
  status?: number;
}

export default class SubjectServices {
  private readonly list_api = '/v1/subtabledef/list';
  private readonly info_api = '/v1/subtabledef/info';
  private readonly save_api = '/v1/subtabledef/save';
  private readonly update_api = '/v1/subtabledef/update';
  private readonly remove_api = '/v1/subtabledef/delete';
  private readonly category_api = '/v1/subtabledef/category';
  private readonly field_list_api = '/v1/subfielddef/list';

  constructor() {}

  async getList(params?: object): Promise<any> {
    let res: any = await http.get(this.list_api, { params: params });
    return res.payload;
  }

  async getEnableList(params?: object): Promise<any> {
    // 0-新建待提交，1-编辑待提交，2-新建已提交，3-编辑已提交，4-新建已审批，5-编辑已审批，6-新建已驳回，7-编辑已驳回
    return await this.getList({ ...params, status_eq: 0, approveStatus_ge: 4, approveStatus_le: 5 });
  }

  async getInfo(id: string | number) {
    let res: any = await http.get(this.info_api + '/' + id);
    return res.payload;
  }

  async getFieldList(params?: object): Promise<any> {
    let res: any = await http.get(this.field_list_api, { params: params });
    return res.payload;
  }

  async add(data: SubjectDto) {
    const params = { ...data, subSort: '1', subCode: 'SUB_' + data.subCode };
    let res: any = await http.post(this.save_api, params);
    return res.header?.code == 200 ? res.payload : false;
  }

  async update(data: SubjectDto): Promise<boolean> {
    let res: any = await http.post(this.update_api, data);
    return res.header?.code == 200;
  }

  async remove(id: string | number) {
    let res: any = await http.post(this.remove_api, [id]);
    return res.header?.code == 200;
  }

  async getTree(params?: object): Promise<any> {
    let res: any = await http.get(this.category_api, { params: params });
    return res.payload;
  }
}
